
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[articleTitle]",
      function () {
        return require("private-next-pages/article/[articleTitle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/[articleTitle]"])
      });
    }
  